/*
  Pure Grounds: "Show more" on the product reviews section. Every published review is in the markup;
  the ones past the first page carry the hidden attribute and are revealed a page at a time, so no
  request is made and the list works without JavaScript (the first page is always visible).
*/
if (!customElements.get('product-reviews')) {
  customElements.define(
    'product-reviews',
    class ProductReviews extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.product-reviews__more');
        if (!this.button || this.button.dataset.bound === 'true') return;
        this.button.dataset.bound = 'true';
        this.button.addEventListener('click', this.showMore.bind(this));
      }

      showMore() {
        const step = Number(this.button.dataset.step) || 5;
        const hidden = Array.from(this.querySelectorAll('.product-reviews__item[hidden]'));
        hidden.slice(0, step).forEach((item) => {
          item.hidden = false;
        });
        if (hidden.length <= step) this.button.hidden = true;
        const revealed = hidden[0];
        if (revealed) {
          revealed.setAttribute('tabindex', '-1');
          revealed.focus({ preventScroll: true });
        }
      }
    }
  );
}
